import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: {
    university: {
      'id': -1,
      'name': 'All'
    },
    universities: [{
      'id': -1,
      'name': 'All'
    }],
    endpoints: {
      universities: 'https://stormy-mountain-29119.herokuapp.com/v3/universities/',
    },
  },
  mutations,
  actions,
  getters,
}